'use client';

import { LAUNCHPAD_PROJECT_STATUS } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { useLaunchpadProjectsListQuery } from '@query/launchpadProjects';

import MainInfo from '@launchpad/components/pages/Main/ui/MainInfo/MainInfo';
import ProjectsSlider from '@launchpad/components/pages/Main/ui/ProjectsSlider/ProjectsSlider';
import NewsletterSubscribeWidget from '@launchpad/components/pages/Main/ui/widgets/NewsletterSubscribeWidget';

import Socials from '../../common/Socials/Socials';
import { MainAdBanner } from './ui/MainAdBanner';

const LIMIT_PROJECTS_LIST = 10;

const Page = () => {
  const activeProjectsQuery = useLaunchpadProjectsListQuery({
    searchParams: { limit: LIMIT_PROJECTS_LIST, status: LAUNCHPAD_PROJECT_STATUS.ACTIVE },
  });
  const upcomingProjectsQuery = useLaunchpadProjectsListQuery({
    searchParams: { limit: LIMIT_PROJECTS_LIST, status: LAUNCHPAD_PROJECT_STATUS.COMING },
  });
  const pastProjectsQuery = useLaunchpadProjectsListQuery({
    searchParams: { limit: LIMIT_PROJECTS_LIST, status: LAUNCHPAD_PROJECT_STATUS.PASSED },
  });

  const { user } = useAuth();

  return (
    <div className="w-full flex-grow overflow-hidden">
      <main className="main-container py-4 sm:py-16">
        <MainInfo />

        <MainAdBanner userId={user?.id} />

        <ProjectsSlider
          status={LAUNCHPAD_PROJECT_STATUS.ACTIVE}
          title="Active Sales"
          titleDecoration={<div className=" w-4 h-4 rounded-full bg-green-700" />}
          className="my-4 md:my-12"
          projectsQuery={activeProjectsQuery}
          viewAllLabel="View All Active Sales"
          showViewAll
        />

        <ProjectsSlider
          status={LAUNCHPAD_PROJECT_STATUS.COMING}
          title="Upcoming Sales"
          titleDecoration={<div className=" w-4 h-4 rounded-full bg-secondary-700" />}
          className="my-4 md:my-12"
          projectsQuery={upcomingProjectsQuery}
          viewAllLabel="View All Available Opportunities"
          showViewAll
        />

        <ProjectsSlider
          status={LAUNCHPAD_PROJECT_STATUS.PASSED}
          title="Past Sales"
          titleDecoration={<div className=" w-4 h-4 rounded-full bg-yellow-600" />}
          className="my-4 md:my-12"
          projectsQuery={pastProjectsQuery}
        />

        <NewsletterSubscribeWidget className="my-4 md:my-12" />
        <Socials />
      </main>
    </div>
  );
};

export default Page;
